import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { AppState } from 'services/types';
import {
    FertilizerProductPerUnitType,
    FertilizerProductUnits
} from 'services/fertilizerEvents/types';
import { makeSelectUnitTypeFieldValue } from 'services/unitTypes/selectors';
import { Props } from './index';

const selectUnits = (state: AppState, props: Props): FertilizerProductUnits =>
    props.units;

const selectPerUnitType = (
    state: AppState,
    props: Props
): FertilizerProductPerUnitType => props.perUnitType;

const selectRate = createDeepEqualSelector(
    selectUnits,
    makeSelectUnitTypeFieldValue('name'),
    selectPerUnitType,
    (units, unitTypeName, perUnitType) =>
        `${units} ${unitTypeName}/${perUnitType}`
);

const makeSelectRate = (): typeof selectRate => selectRate;

export { makeSelectRate };
